import { render, staticRenderFns } from "./inviteUser.vue?vue&type=template&id=0463d64e&scoped=true&"
import script from "./inviteUser.vue?vue&type=script&lang=js&"
export * from "./inviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463d64e",
  null
  
)

export default component.exports